import type { IAugmentedJQuery, IController, IScope } from "angular";

import type { IPoint } from "App/Modules/Models";

export default class SvgLineDirectiveController implements IController {
    public static $inject = ["$scope", "$element", "mmSvgService"];

    public points: IPoint[];

    public create?: boolean;

    public editable?: boolean;

    public editing?: boolean;

    public onEditing?: (args: { editing: boolean }) => void;

    public center: IPoint;

    public pointsString: string;

    private svgRoot: SVGSVGElement;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery, private svgService: any) {}

    public $onInit() {
        this.editing = this.create || this.editing || false;
        this.editable = this.editable || false;

        this.svgRoot = this.svgService.getSvgRoot(this.$element[0]);

        this.updatePoints();

        this.$scope.$watch("$ctrl.points", () => this.updatePoints(), true);

        this.$scope.$watch("$ctrl.editable", (newValue) => {
            if (!newValue) {
                this.editing = false;
            }
        });
    }

    public lineClicked() {
        if (this.editable) {
            this.editing = !this.editing;
            if (this.onEditing) {
                this.onEditing({ editing: this.editing });
            }
        }
    }

    private updatePoints() {
        this.pointsString = this.pointsToSvgString(this.points);
        this.center = this.average(this.points);
        this.center.x += 0.05;
    }

    private average(points: IPoint[]): IPoint {
        return points.reduce(
            (current: IPoint, point: IPoint) => {
                current.x += point.x / points.length;
                current.y += point.y / points.length;
                return current;
            },
            { x: 0.0, y: 0.0 },
        );
    }

    private pointsToSvgString(points: IPoint[]): string {
        return points.map((p) => `${p.x},${p.y}`).join(" ");
    }
}
